import {
  isNeedToShowPrivacy,
  initRegForm,
  initSubmitButton,
  getErrorRegFallBecauseOfAttendeeNull,
  initPrivacyPolicyLink,
  prepareRegPage,
} from './registration/index.js';
import { validatePageParams, validationVariants, fetchData } from './page.js';
import { setBackground, setLogo } from './customizePage/registration.js';
import { redirectToPage } from './page-routes.js';
import multiAccounts from './multiAccounts/index.ts';
import { createAttendee } from './utils-module.js';
import { calculateExpiredDate } from './multiAccounts/data.ts';
import { initEventLoc, t } from './localization.js';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();
const { isSetUpEventName } = validationVariants;

async function init() {
  prepareRegPage();

  if (!validatePageParams([isSetUpEventName])) {
    return;
  }

  initPrivacyPolicyLink();
  const event = await fetchData.event();
  if (!event) return;

  const { opts } = event;
  await initEventLoc(event);

  const form = initRegForm();

  if (event.organisation) {
    eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
  }

  const { submitButton, submitButtonText } = initSubmitButton();

  setLogo(opts.webappCustomLogoSrc);
  setBackground(opts.webappCustomBackgroundSrc);

  if (opts.webappIsEnabledSMS) {
    form.enablePhoneNumber();
  }

  if (await isNeedToShowPrivacy()) {
    form.enableAgreePrivacy();
  }

  form.onSubmit(async ({ name, email, phoneNumber }) => {
    if (submitButton) {
      submitButton.textContent = t('registration-submit-loading-label');
    }
    try {
      const { result: attendeeUid } = await createAttendee({
        eventCode: event.name,
        name,
        email,
        phoneNumber,
      });
      if (!attendeeUid) {
        if (submitButton) {
          submitButton.textContent = submitButtonText;
          submitButton.disabled = false;
        }
        alert(getErrorRegFallBecauseOfAttendeeNull({ canBeEmailConfirmationProblem: true }));
        return;
      }
      const regDate = new Date();
      multiAccounts.addAccount({
        attendeeUid,
        eventCode: event.name,
        eventLogo: opts.webappCustomLogoSrc,
        name,
        email,
        phoneNumber,
        regDate,
        expiredDate: calculateExpiredDate(event, { created_date: regDate }),
      });
      multiAccounts.setCurrentAccount(0);
      redirectToPage.index({ rawSearch: globalThis.location.search });
    } catch (error) {
      console.error('Error creating attendee:', error);
      if (submitButton) {
        submitButton.textContent = submitButtonText;
        submitButton.disabled = false;
      }
      throw error;
    }
  });
}

document.addEventListener('DOMContentLoaded', init);
